<div *ngIf="control.errors && control.touched"
  class="input_error">
  <img *ngIf="showIcon"
    src="/assets/svgs/i_exclamation_triangle_red.svg"
    alt="icone de exclamação">
  {{ control | validMsgPipe:fieldName }}
</div>

<div *ngIf="hint && (!control.errors || !control.touched)"
  class="input_hint">
  {{ hint }}
</div>
